export type AppearanceIntent = 'light' | 'dark' | 'system';
export type ResolvedAppearance = 'light' | 'dark';

/**
 * Pinned per d45_mode_wiring_decision.md §4 item 1 — this is Paire's own
 * intent store, deliberately separate from Chakra's "chakra-ui-color-mode"
 * key (which only ever holds the resolved value, not the three-way intent).
 */
export const APPEARANCE_STORAGE_KEY = 'paire.appearance';
